/* tslint:disable */
/* eslint-disable */
/**
 * Price and Capacity Track & automatic reserve Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ApplyUserScoreDiscountResponseDto } from '../model';
// @ts-ignore
import { AutoReservesDetail } from '../model';
// @ts-ignore
import { AutomaticReserveCancellationReasonResponse } from '../model';
// @ts-ignore
import { AutomaticReserveDemandDto } from '../model';
// @ts-ignore
import { AutomaticReserveDemandRequest } from '../model';
// @ts-ignore
import { AutomaticReserveDemandResponse } from '../model';
// @ts-ignore
import { AutomaticReserveDemandResponsePagedResponse } from '../model';
// @ts-ignore
import { AutomaticReserveDetailsResponseDto } from '../model';
// @ts-ignore
import { AutomaticReservePaymentUrl } from '../model';
// @ts-ignore
import { AutomaticReservePeopleResponse } from '../model';
// @ts-ignore
import { CalculateAutomaticReserveDemandItemSuccessRateRequestDto } from '../model';
// @ts-ignore
import { CalculateAutomaticReserveRouteDemandItemSuccessRateRequestDto } from '../model';
// @ts-ignore
import { CancellationRequest } from '../model';
// @ts-ignore
import { CreateDemandAutomaticReserveCommandResponse } from '../model';
// @ts-ignore
import { EditAutomaticReserceResponseDto } from '../model';
// @ts-ignore
import { EditAutomaticReserveDemandRequestDto } from '../model';
// @ts-ignore
import { GetAutomaticReserveCoefficientDto } from '../model';
// @ts-ignore
import { GetAutomaticReservePrice } from '../model';
// @ts-ignore
import { GetAutomicReserveDemandItemsAvailabilityResponse } from '../model';
// @ts-ignore
import { GetUserInProcessAutomaticReserveTripCountResponse } from '../model';
// @ts-ignore
import { InProcessAutomaticReserveDemandRequest } from '../model';
// @ts-ignore
import { PeopleResponse } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { RegisterAutomaticReservePeopleRequestDto } from '../model';
// @ts-ignore
import { RegisterAutomaticReservePeopleResponseDto } from '../model';
// @ts-ignore
import { ServiceType } from '../model';
// @ts-ignore
import { UpdateAutomaticReserveCoeffiecientRequestDto } from '../model';
// @ts-ignore
import { UserScoreDiscountRequestDto } from '../model';
/**
 * AutomaticReserveApiApiAdminAutomaticReserveGet - axios parameter creator
 * 
 * @summary get the automatic reserve demands of user for admin
 * @param {number} [userId] 
 * @param {number} [pageNumber] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAdminAutomaticReserveGetAxiosParamCreator (userId?: number, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/admin/AutomaticReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }

    if (pageNumber !== undefined) {
        localVarQueryParameter['PageNumber'] = pageNumber;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAdminAutomaticReserveIdDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {CancellationRequest} [cancellationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAdminAutomaticReserveIdDeleteAxiosParamCreator (id: number, cancellationRequest?: CancellationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAdminAutomaticReserveIdDelete', 'id', id)
    const localVarPath = `/api/admin/AutomaticReserve/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancellationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {Array<number>} [requestBody] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteAxiosParamCreator (id: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAdminAutomaticReserveIdPeopleDelete', 'id', id)
    const localVarPath = `/api/admin/AutomaticReserve/{id}/people`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPost - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveAddAutomaticReserveDemandDraftIdPost', 'id', id)
    const localVarPath = `/api/AutomaticReserve/AddAutomaticReserveDemandDraft/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPost - axios parameter creator
 * 
 * @param {string} [xPlayerId] 
 * @param {UserScoreDiscountRequestDto} [userScoreDiscountRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostAxiosParamCreator (xPlayerId?: string, userScoreDiscountRequestDto?: UserScoreDiscountRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/AddUserScoreDiscount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userScoreDiscountRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePost - axios parameter creator
 * 
 * @param {CalculateAutomaticReserveDemandItemSuccessRateRequestDto} [calculateAutomaticReserveDemandItemSuccessRateRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostAxiosParamCreator (calculateAutomaticReserveDemandItemSuccessRateRequestDto?: CalculateAutomaticReserveDemandItemSuccessRateRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/CalculateAutomaticReserveDemandItemSuccessRate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(calculateAutomaticReserveDemandItemSuccessRateRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePost - axios parameter creator
 * 
 * @param {CalculateAutomaticReserveRouteDemandItemSuccessRateRequestDto} [calculateAutomaticReserveRouteDemandItemSuccessRateRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostAxiosParamCreator (calculateAutomaticReserveRouteDemandItemSuccessRateRequestDto?: CalculateAutomaticReserveRouteDemandItemSuccessRateRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/CalculateAutomaticReserveRouteDemandItemSuccessRate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(calculateAutomaticReserveRouteDemandItemSuccessRateRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDelete - axios parameter creator
 * 
 * @param {number} automaticReserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteAxiosParamCreator (automaticReserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'automaticReserveId' is not null or undefined
    assertParamExists('apiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDelete', 'automaticReserveId', automaticReserveId)
    const localVarPath = `/api/AutomaticReserve/CancelAutomaticReserve/{automaticReserveId}`
        .replace(`{${"automaticReserveId"}}`, encodeURIComponent(String(automaticReserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatch - axios parameter creator
 * 
 * @summary cancel a automatic reserve response
 * @param {number} automaticReserveDemandId 
 * @param {CancellationRequest} [cancellationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchAxiosParamCreator (automaticReserveDemandId: number, cancellationRequest?: CancellationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'automaticReserveDemandId' is not null or undefined
    assertParamExists('apiAutomaticReserveCancelAutomaticReserveDemandIdPatch', 'automaticReserveDemandId', automaticReserveDemandId)
    const localVarPath = `/api/AutomaticReserve/Cancel/{automaticReserveDemandId}`
        .replace(`{${"automaticReserveDemandId"}}`, encodeURIComponent(String(automaticReserveDemandId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancellationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPost - axios parameter creator
 * 
 * @summary This method only Exists because app made a mistake and calls this! You should not use this.
 * @param {number} automaticReserveDemandId 
 * @param {CancellationRequest} [cancellationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostAxiosParamCreator (automaticReserveDemandId: number, cancellationRequest?: CancellationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'automaticReserveDemandId' is not null or undefined
    assertParamExists('apiAutomaticReserveCancelAutomaticReserveDemandIdPost', 'automaticReserveDemandId', automaticReserveDemandId)
    const localVarPath = `/api/AutomaticReserve/Cancel/{automaticReserveDemandId}`
        .replace(`{${"automaticReserveDemandId"}}`, encodeURIComponent(String(automaticReserveDemandId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancellationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCancellationReasonsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCancellationReasonsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/CancellationReasons`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet - axios parameter creator
 * 
 * @param {number} automaticReserveId 
 * @param {boolean} [isOptionalUrl] 
 * @param {string} [accessToken] 
 * @param {boolean} [isRequestTotalPricePayment] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetAxiosParamCreator (automaticReserveId: number, isOptionalUrl?: boolean, accessToken?: string, isRequestTotalPricePayment?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'automaticReserveId' is not null or undefined
    assertParamExists('apiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet', 'automaticReserveId', automaticReserveId)
    const localVarPath = `/api/AutomaticReserve/ConfirmAutomaticReserveDemand/{automaticReserveId}`
        .replace(`{${"automaticReserveId"}}`, encodeURIComponent(String(automaticReserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (isOptionalUrl !== undefined) {
        localVarQueryParameter['isOptionalUrl'] = isOptionalUrl;
    }

    if (accessToken !== undefined) {
        localVarQueryParameter['accessToken'] = accessToken;
    }

    if (isRequestTotalPricePayment !== undefined) {
        localVarQueryParameter['isRequestTotalPricePayment'] = isRequestTotalPricePayment;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveCountGet - axios parameter creator
 * 
 * @summary get the total count of the trip for current user that we are working on
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/Count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPost - axios parameter creator
 * 
 * @param {string} [xPlayerID] 
 * @param {string} [userAgent] 
 * @param {EditAutomaticReserveDemandRequestDto} [editAutomaticReserveDemandRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostAxiosParamCreator (xPlayerID?: string, userAgent?: string, editAutomaticReserveDemandRequestDto?: EditAutomaticReserveDemandRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/EditAutomaticReserveDemand`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }

    if (userAgent != null) {
        localVarHeaderParameter['User-Agent'] = String(userAgent);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editAutomaticReserveDemandRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGet - axios parameter creator
 * 
 * @summary get the automatic reserve demands of current user
 * @param {number} [pageNumber] 
 * @param {number} [pageSize] 
 * @param {boolean} [current] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetAxiosParamCreator (pageNumber?: number, pageSize?: number, current?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (pageNumber !== undefined) {
        localVarQueryParameter['PageNumber'] = pageNumber;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }

    if (current !== undefined) {
        localVarQueryParameter['Current'] = current;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAutomaticReserveGetAutoReserveInfoBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/AutomaticReserve/GetAutoReserveInfo/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveCoeffiecientsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveCoeffiecientsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/GetAutomaticReserveCoeffiecients`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGet - axios parameter creator
 * 
 * @param {number} [id] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetAxiosParamCreator (id?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/GetAutomaticReserveDetailsById`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (id !== undefined) {
        localVarQueryParameter['id'] = id;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPost - axios parameter creator
 * 
 * @param {AutomaticReserveDemandRequest} [automaticReserveDemandRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostAxiosParamCreator (automaticReserveDemandRequest?: AutomaticReserveDemandRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/GetAutomicReserveDemandItemsAvailability`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(automaticReserveDemandRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveGetUserAutomaticReserveDemandDraftsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveGetUserAutomaticReserveDemandDraftsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/GetUserAutomaticReserveDemandDrafts`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveIdGet - axios parameter creator
 * 
 * @summary Get user auto reserve info
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveIdGetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveIdGet', 'id', id)
    const localVarPath = `/api/AutomaticReserve/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveIdPaymentGet - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveIdPaymentGetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveIdPaymentGet', 'id', id)
    const localVarPath = `/api/AutomaticReserve/{id}/payment`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveIdPeopleDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {Array<number>} [requestBody] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteAxiosParamCreator (id: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveIdPeopleDelete', 'id', id)
    const localVarPath = `/api/AutomaticReserve/{id}/people`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveIdPeopleGet - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @deprecated
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveIdPeopleGetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveIdPeopleGet', 'id', id)
    const localVarPath = `/api/AutomaticReserve/{id}/people`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveIdPeopleV2Get - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveIdPeopleV2Get', 'id', id)
    const localVarPath = `/api/AutomaticReserve/{id}/people-v2`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReservePaymentCallbackPost - axios parameter creator
 * 
 * @summary call back of the charge credit
 * @param {InProcessAutomaticReserveDemandRequest} [inProcessAutomaticReserveDemandRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReservePaymentCallbackPostAxiosParamCreator (inProcessAutomaticReserveDemandRequest?: InProcessAutomaticReserveDemandRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/PaymentCallback`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(inProcessAutomaticReserveDemandRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReservePost - axios parameter creator
 * 
 * @summary request for adding the automatic reserve
 * @param {string} [xPlayerID] 
 * @param {string} [userAgent] 
 * @param {AutomaticReserveDemandRequest} [automaticReserveDemandRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReservePostAxiosParamCreator (xPlayerID?: string, userAgent?: string, automaticReserveDemandRequest?: AutomaticReserveDemandRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }

    if (userAgent != null) {
        localVarHeaderParameter['User-Agent'] = String(userAgent);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(automaticReserveDemandRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReservePriceGet - axios parameter creator
 * 
 * @summary get the price of the automatic reserve
 * @param {string} [date] 
 * @param {string} [origin] 
 * @param {string} [destination] 
 * @param {ServiceType} [serviceType] 
 * @param {string} [giftMacValueMac] 
 * @param {string} [giftMacValueGiftCode] 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReservePriceGetAxiosParamCreator (date?: string, origin?: string, destination?: string, serviceType?: ServiceType, giftMacValueMac?: string, giftMacValueGiftCode?: string, xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/Price`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (date !== undefined) {
        localVarQueryParameter['Date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (origin !== undefined) {
        localVarQueryParameter['Origin'] = origin;
    }

    if (destination !== undefined) {
        localVarQueryParameter['Destination'] = destination;
    }

    if (serviceType !== undefined) {
        localVarQueryParameter['ServiceType'] = serviceType;
    }

    if (giftMacValueMac !== undefined) {
        localVarQueryParameter['GiftMacValue.Mac'] = giftMacValueMac;
    }

    if (giftMacValueGiftCode !== undefined) {
        localVarQueryParameter['GiftMacValue.GiftCode'] = giftMacValueGiftCode;
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePost - axios parameter creator
 * 
 * @param {string} [xPlayerID] 
 * @param {string} [userAgent] 
 * @param {RegisterAutomaticReservePeopleRequestDto} [registerAutomaticReservePeopleRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostAxiosParamCreator (xPlayerID?: string, userAgent?: string, registerAutomaticReservePeopleRequestDto?: RegisterAutomaticReservePeopleRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/RegisterAutomaticReservePeople`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }

    if (userAgent != null) {
        localVarHeaderParameter['User-Agent'] = String(userAgent);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerAutomaticReservePeopleRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDelete', 'id', id)
    const localVarPath = `/api/AutomaticReserve/RemoveAutomaticReserveDemandDraft/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPost - axios parameter creator
 * 
 * @param {string} [xPlayerId] 
 * @param {UserScoreDiscountRequestDto} [userScoreDiscountRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostAxiosParamCreator (xPlayerId?: string, userScoreDiscountRequestDto?: UserScoreDiscountRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/RemoveUserScoreDiscount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userScoreDiscountRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPost - axios parameter creator
 * 
 * @summary call back set in process the demand
 * @param {number} automaticReserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostAxiosParamCreator (automaticReserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'automaticReserveId' is not null or undefined
    assertParamExists('apiAutomaticReserveSetInProcessAutomaticReserveIdPost', 'automaticReserveId', automaticReserveId)
    const localVarPath = `/api/AutomaticReserve/SetInProcess/{automaticReserveId}`
        .replace(`{${"automaticReserveId"}}`, encodeURIComponent(String(automaticReserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPut - axios parameter creator
 * 
 * @param {UpdateAutomaticReserveCoeffiecientRequestDto} [updateAutomaticReserveCoeffiecientRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutAxiosParamCreator (updateAutomaticReserveCoeffiecientRequestDto?: UpdateAutomaticReserveCoeffiecientRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AutomaticReserve/UpdateAutomaticReserveCoeffiecients`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateAutomaticReserveCoeffiecientRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminAutomaticReserveGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAdminAutomaticReserveGetRequest
 */
export interface AutomaticReserveApiApiAdminAutomaticReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveGet
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiAdminAutomaticReserveIdDelete operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAdminAutomaticReserveIdDeleteRequest
 */
export interface AutomaticReserveApiApiAdminAutomaticReserveIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveIdDelete
     */
    readonly id: number

    /**
     * 
     * @type {CancellationRequest}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveIdDelete
     */
    readonly cancellationRequest?: CancellationRequest
}

/**
 * Request parameters for apiAdminAutomaticReserveIdPeopleDelete operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteRequest
 */
export interface AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDelete
     */
    readonly id: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDelete
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiAutomaticReserveAddAutomaticReserveDemandDraftIdPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPost
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReserveAddUserScoreDiscountPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {UserScoreDiscountRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPost
     */
    readonly userScoreDiscountRequestDto?: UserScoreDiscountRequestDto
}

/**
 * Request parameters for apiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostRequest {
    /**
     * 
     * @type {CalculateAutomaticReserveDemandItemSuccessRateRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePost
     */
    readonly calculateAutomaticReserveDemandItemSuccessRateRequestDto?: CalculateAutomaticReserveDemandItemSuccessRateRequestDto
}

/**
 * Request parameters for apiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostRequest {
    /**
     * 
     * @type {CalculateAutomaticReserveRouteDemandItemSuccessRateRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePost
     */
    readonly calculateAutomaticReserveRouteDemandItemSuccessRateRequestDto?: CalculateAutomaticReserveRouteDemandItemSuccessRateRequestDto
}

/**
 * Request parameters for apiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDelete operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDelete
     */
    readonly automaticReserveId: number
}

/**
 * Request parameters for apiAutomaticReserveCancelAutomaticReserveDemandIdPatch operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatch
     */
    readonly automaticReserveDemandId: number

    /**
     * 
     * @type {CancellationRequest}
     * @memberof AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatch
     */
    readonly cancellationRequest?: CancellationRequest
}

/**
 * Request parameters for apiAutomaticReserveCancelAutomaticReserveDemandIdPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPost
     */
    readonly automaticReserveDemandId: number

    /**
     * 
     * @type {CancellationRequest}
     * @memberof AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPost
     */
    readonly cancellationRequest?: CancellationRequest
}

/**
 * Request parameters for apiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet
     */
    readonly automaticReserveId: number

    /**
     * 
     * @type {boolean}
     * @memberof AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet
     */
    readonly isOptionalUrl?: boolean

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet
     */
    readonly accessToken?: string

    /**
     * 
     * @type {boolean}
     * @memberof AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet
     */
    readonly isRequestTotalPricePayment?: boolean
}

/**
 * Request parameters for apiAutomaticReserveEditAutomaticReserveDemandPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPost
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPost
     */
    readonly userAgent?: string

    /**
     * 
     * @type {EditAutomaticReserveDemandRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPost
     */
    readonly editAutomaticReserveDemandRequestDto?: EditAutomaticReserveDemandRequestDto
}

/**
 * Request parameters for apiAutomaticReserveGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof AutomaticReserveApiApiAutomaticReserveGet
     */
    readonly current?: boolean
}

/**
 * Request parameters for apiAutomaticReserveGetAutoReserveInfoBillCodeGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAutomaticReserveGetAutomaticReserveDetailsByIdGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGet
     */
    readonly id?: number
}

/**
 * Request parameters for apiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostRequest {
    /**
     * 
     * @type {AutomaticReserveDemandRequest}
     * @memberof AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPost
     */
    readonly automaticReserveDemandRequest?: AutomaticReserveDemandRequest
}

/**
 * Request parameters for apiAutomaticReserveIdGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveIdGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReserveIdPaymentGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveIdPaymentGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveIdPaymentGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdPaymentGet
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReserveIdPeopleDelete operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdPeopleDelete
     */
    readonly id: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdPeopleDelete
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiAutomaticReserveIdPeopleGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveIdPeopleGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveIdPeopleGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdPeopleGet
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReserveIdPeopleV2Get operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveIdPeopleV2Get
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReservePaymentCallbackPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReservePaymentCallbackPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReservePaymentCallbackPostRequest {
    /**
     * 
     * @type {InProcessAutomaticReserveDemandRequest}
     * @memberof AutomaticReserveApiApiAutomaticReservePaymentCallbackPost
     */
    readonly inProcessAutomaticReserveDemandRequest?: InProcessAutomaticReserveDemandRequest
}

/**
 * Request parameters for apiAutomaticReservePost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReservePostRequest
 */
export interface AutomaticReserveApiApiAutomaticReservePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePost
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePost
     */
    readonly userAgent?: string

    /**
     * 
     * @type {AutomaticReserveDemandRequest}
     * @memberof AutomaticReserveApiApiAutomaticReservePost
     */
    readonly automaticReserveDemandRequest?: AutomaticReserveDemandRequest
}

/**
 * Request parameters for apiAutomaticReservePriceGet operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReservePriceGetRequest
 */
export interface AutomaticReserveApiApiAutomaticReservePriceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly origin?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly destination?: string

    /**
     * 
     * @type {ServiceType}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly serviceType?: ServiceType

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly giftMacValueMac?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly giftMacValueGiftCode?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReservePriceGet
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiAutomaticReserveRegisterAutomaticReservePeoplePost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePost
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePost
     */
    readonly userAgent?: string

    /**
     * 
     * @type {RegisterAutomaticReservePeopleRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePost
     */
    readonly registerAutomaticReservePeopleRequestDto?: RegisterAutomaticReservePeopleRequestDto
}

/**
 * Request parameters for apiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDelete operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiAutomaticReserveRemoveUserScoreDiscountPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPost
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {UserScoreDiscountRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPost
     */
    readonly userScoreDiscountRequestDto?: UserScoreDiscountRequestDto
}

/**
 * Request parameters for apiAutomaticReserveSetInProcessAutomaticReserveIdPost operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPost
     */
    readonly automaticReserveId: number
}

/**
 * Request parameters for apiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPut operation in AutomaticReserveApi.
 * @export
 * @interface AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutRequest
 */
export interface AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutRequest {
    /**
     * 
     * @type {UpdateAutomaticReserveCoeffiecientRequestDto}
     * @memberof AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPut
     */
    readonly updateAutomaticReserveCoeffiecientRequestDto?: UpdateAutomaticReserveCoeffiecientRequestDto
}

/**
* 
* @summary get the automatic reserve demands of user for admin
* @param {AutomaticReserveApiApiAdminAutomaticReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAdminAutomaticReserveGet(requestParameters: AutomaticReserveApiApiAdminAutomaticReserveGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAdminAutomaticReserveGetAxiosParamCreator(requestParameters.userId, requestParameters.pageNumber, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<AutomaticReserveDemandResponsePagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAdminAutomaticReserveIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAdminAutomaticReserveIdDelete(requestParameters: AutomaticReserveApiApiAdminAutomaticReserveIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAdminAutomaticReserveIdDeleteAxiosParamCreator(requestParameters.id, requestParameters.cancellationRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDelete(requestParameters: AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAdminAutomaticReserveIdPeopleDeleteAxiosParamCreator(requestParameters.id, requestParameters.requestBody, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPost(requestParameters: AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveAddAutomaticReserveDemandDraftIdPostAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPost(requestParameters: AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveAddUserScoreDiscountPostAxiosParamCreator(requestParameters.xPlayerId, requestParameters.userScoreDiscountRequestDto, options, configuration);
    const request: () => AxiosPromise<ApplyUserScoreDiscountResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePost(requestParameters: AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveDemandItemSuccessRatePostAxiosParamCreator(requestParameters.calculateAutomaticReserveDemandItemSuccessRateRequestDto, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePost(requestParameters: AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCalculateAutomaticReserveRouteDemandItemSuccessRatePostAxiosParamCreator(requestParameters.calculateAutomaticReserveRouteDemandItemSuccessRateRequestDto, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDelete(requestParameters: AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveAutomaticReserveIdDeleteAxiosParamCreator(requestParameters.automaticReserveId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary cancel a automatic reserve response
* @param {AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatch(requestParameters: AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPatchAxiosParamCreator(requestParameters.automaticReserveDemandId, requestParameters.cancellationRequest, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary This method only Exists because app made a mistake and calls this! You should not use this.
* @param {AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPost(requestParameters: AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCancelAutomaticReserveDemandIdPostAxiosParamCreator(requestParameters.automaticReserveDemandId, requestParameters.cancellationRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCancellationReasonsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCancellationReasonsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<AutomaticReserveCancellationReasonResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGet(requestParameters: AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveConfirmAutomaticReserveDemandAutomaticReserveIdGetAxiosParamCreator(requestParameters.automaticReserveId, requestParameters.isOptionalUrl, requestParameters.accessToken, requestParameters.isRequestTotalPricePayment, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get the total count of the trip for current user that we are working on
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GetUserInProcessAutomaticReserveTripCountResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPost(requestParameters: AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveEditAutomaticReserveDemandPostAxiosParamCreator(requestParameters.xPlayerID, requestParameters.userAgent, requestParameters.editAutomaticReserveDemandRequestDto, options, configuration);
    const request: () => AxiosPromise<EditAutomaticReserceResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get the automatic reserve demands of current user
* @param {AutomaticReserveApiApiAutomaticReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGet(requestParameters: AutomaticReserveApiApiAutomaticReserveGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetAxiosParamCreator(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.current, options, configuration);
    const request: () => AxiosPromise<AutoReservesDetail> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGet(requestParameters: AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetAutoReserveInfoBillCodeGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<AutomaticReserveDemandDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveCoeffiecientsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveCoeffiecientsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GetAutomaticReserveCoefficientDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGet(requestParameters: AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetAutomaticReserveDetailsByIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<AutomaticReserveDetailsResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPost(requestParameters: AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetAutomicReserveDemandItemsAvailabilityPostAxiosParamCreator(requestParameters.automaticReserveDemandRequest, options, configuration);
    const request: () => AxiosPromise<GetAutomicReserveDemandItemsAvailabilityResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveGetUserAutomaticReserveDemandDraftsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveGetUserAutomaticReserveDemandDraftsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<AutomaticReserveDemandResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get user auto reserve info
* @param {AutomaticReserveApiApiAutomaticReserveIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveIdGet(requestParameters: AutomaticReserveApiApiAutomaticReserveIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<AutomaticReserveDemandDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveIdPaymentGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveIdPaymentGet(requestParameters: AutomaticReserveApiApiAutomaticReserveIdPaymentGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveIdPaymentGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<AutomaticReservePaymentUrl> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveIdPeopleDelete(requestParameters: AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveIdPeopleDeleteAxiosParamCreator(requestParameters.id, requestParameters.requestBody, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveIdPeopleGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @deprecated
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveIdPeopleGet(requestParameters: AutomaticReserveApiApiAutomaticReserveIdPeopleGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveIdPeopleGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<Array<PeopleResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveIdPeopleV2Get(requestParameters: AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveIdPeopleV2GetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<AutomaticReservePeopleResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary call back of the charge credit
* @param {AutomaticReserveApiApiAutomaticReservePaymentCallbackPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReservePaymentCallbackPost(requestParameters: AutomaticReserveApiApiAutomaticReservePaymentCallbackPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReservePaymentCallbackPostAxiosParamCreator(requestParameters.inProcessAutomaticReserveDemandRequest, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary request for adding the automatic reserve
* @param {AutomaticReserveApiApiAutomaticReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReservePost(requestParameters: AutomaticReserveApiApiAutomaticReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReservePostAxiosParamCreator(requestParameters.xPlayerID, requestParameters.userAgent, requestParameters.automaticReserveDemandRequest, options, configuration);
    const request: () => AxiosPromise<CreateDemandAutomaticReserveCommandResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get the price of the automatic reserve
* @param {AutomaticReserveApiApiAutomaticReservePriceGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReservePriceGet(requestParameters: AutomaticReserveApiApiAutomaticReservePriceGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReservePriceGetAxiosParamCreator(requestParameters.date, requestParameters.origin, requestParameters.destination, requestParameters.serviceType, requestParameters.giftMacValueMac, requestParameters.giftMacValueGiftCode, requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<GetAutomaticReservePrice> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePost(requestParameters: AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveRegisterAutomaticReservePeoplePostAxiosParamCreator(requestParameters.xPlayerID, requestParameters.userAgent, requestParameters.registerAutomaticReservePeopleRequestDto, options, configuration);
    const request: () => AxiosPromise<RegisterAutomaticReservePeopleResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDelete(requestParameters: AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveRemoveAutomaticReserveDemandDraftIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPost(requestParameters: AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveRemoveUserScoreDiscountPostAxiosParamCreator(requestParameters.xPlayerId, requestParameters.userScoreDiscountRequestDto, options, configuration);
    const request: () => AxiosPromise<ApplyUserScoreDiscountResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary call back set in process the demand
* @param {AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPost(requestParameters: AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveSetInProcessAutomaticReserveIdPostAxiosParamCreator(requestParameters.automaticReserveId, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPut(requestParameters: AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AutomaticReserveApiApiAutomaticReserveUpdateAutomaticReserveCoeffiecientsPutAxiosParamCreator(requestParameters.updateAutomaticReserveCoeffiecientRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
